import React, { Component } from "react";
import {
  Tabs,
  TabList,
  Tab,
  DragTab,
  PanelList,
  Panel,
  ExtraButton,
} from "react-tabtab";
import * as customStyle from "react-tabtab/lib/themes/material-design";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Line, Doughnut } from "react-chartjs-2";

import Overview from "./Overview";
import Analysis from "./Analysis";
import TimeLine from "./TimeLine";

export default class SpecificTestReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barChart: {
        labels: ["Passed", "Failed"],
        datasets: [
          {
            label: "Passed-Failed Persentage",
            fill: false,
            data: [60, 40],
          },
        ],
      },
      data: [],
      columns: [
        {
          name: "User",
          selector: "name",
          sortable: true,
        },
        {
          name: "Date",
          selector: "date",
          sortable: true,
          right: true,
        },
        {
          name: "Result",
          selector: "result",
          sortable: true,
          right: true,
          cell: (row) => <div className="d-flex">{row.result}</div>,
        },
        {
          name: "Score",
          selector: "score",
          sortable: true,
          right: true,
          cell: (row) => <div className="d-flex">{row.score}</div>,
        },
        {
          name: "Time",
          selector: "time",
          sortable: true,
          right: true,
          cell: (row) => <div className="d-flex">{row.time}</div>,
        },
        {
          name: "Bio",
          selector: "bio",
          sortable: true,
          right: true,
          cell: (row) => <div className="d-flex">{row.bio}</div>,
        },
        {
          name: "ID",
          selector: "id",
          sortable: true,
          right: true,
          cell: (row) => (
            <div className="d-flex">
              {row.assignedID !== undefined ? <p>row.assignedID</p> : "-"}
            </div>
          ),
        },
        {
          name: "Options",
          selector: "year",
          sortable: true,
          right: true,
          cell: (row) => (
            <div className="d-flex">
              <Link to={`/admin/reports/user/${row.id}`}>
                <i
                  class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
                  id={row.id}
                ></i>
              </Link>
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
                id={row.id}
                onClick={this.handleRefresh}
              ></i>
            </div>
          ),
        },
      ],
    };
  }

  handleRefresh = (event) => {
    event.preventDefault();
  };

  componentDidMount() {}

  render() {
    return (
      <div>
        <div class="row">
          <div class="col-12">
            <Tabs customStyle={customStyle}>
              <TabList>
                <Tab>
                  <i class="fas fa-sliders-h"></i> Overview
                </Tab>
                <Tab>
                  <i class="fas fa-users"></i> Analysis
                </Tab>
                <Tab>
                  <i class="fas fa-palette"></i> TimeLine
                </Tab>
              </TabList>
              <PanelList>
                <Panel>
                  <Overview />
                </Panel>
                <Panel>
                  <Analysis />
                </Panel>
                <Panel>
                  <TimeLine />
                </Panel>
              </PanelList>
            </Tabs>
          </div>
        </div>
        <div className="row">
          <div className="users-container p-2 col-8">
            <DataTable
              noHeader={false}
              columns={this.state.columns}
              data={this.state.data}
              theme="solarized"
              pagination={true}
            />
          </div>
          <div className="col-4">
            <div className="row">
              <div className="col-6">
                <div className="btn-group">
                  <div className="btn btn-light active">Today</div>
                  <div className="btn btn-light">Yesterday</div>
                  <div className="btn btn-light">Week</div>
                  <div className="btn btn-light">Month</div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <div className="btn-group">
                  <div className="btn btn-light active">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <div className="btn btn-light">
                    <i class="fas fa-list-ul"></i>
                  </div>
                </div>
              </div>
              <Doughnut data={this.state.barChart}></Doughnut>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
